import React, { useState, useEffect, startTransition } from 'react';
import './ProgressBar.css'; // Import the CSS file

const ProgressBarFancy = ({
  initialValue = 0,
  finalValue = 100,
  duration = 3000,
}: {
  initialValue: number;
  finalValue: number;
  duration: number;
}) => {
  const [progress, setProgress] = useState(initialValue);

  useEffect(() => {
    let startTime: any;
    const animate = (currentTime: any) => {
      if (!currentTime) {
        return;
      }
      if (!startTime) {
        startTime = currentTime;
      }
      const timeElapsed = currentTime - startTime;
      const progressValue = Math.min((timeElapsed / duration) * finalValue, finalValue);
      startTransition(() => setProgress(progressValue));
      if (timeElapsed < duration) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [finalValue, duration]);

  return (
    <div className='progress-bar'>
      <div className='progress-bar-fill' style={{ width: `${progress}%` }}>
        {/*<span className='progress-bar-text'>{Math.round(progress)}%</span>*/}
      </div>
    </div>
  );
};

export default ProgressBarFancy;
